import { Guideline } from 'shared/hooks/usePasswordGuidelines/types'
import styles from './styles.module.scss'

interface Props {
  rules: Guideline[]
}

const PasswordGuidelines = ({ rules }: Props) => {
  return (
    <div className={styles.container}>
      <ul>
        {rules.map(({ id, label, state }) => (
          <li key={id} className={styles[state]}>
            {label}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default PasswordGuidelines
